// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__FF_Lr","infoBtn":"quickbooks_infoBtn__T-nMX","formBox":"quickbooks_formBox__22gHw","formFooter":"quickbooks_formFooter__1eYuS"};